
/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($, _c, undefined) {
	'use strict';

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.

	var Sage = {
		// All pages
		'common': {
			init: function() {
				// JavaScript to be fired on all pages
				$('p:empty').remove();

				$('.hamburger').on('click', function() {
					$('.topnav').css('display', 'block');
				});
				$(window).resize(function(){
					$('.hamburger').removeClass('is-active');
				});

				$('#login-button').on('click', function(e){
					e.preventDefault();
					$('#login').toggleClass('hide-me').addClass('animated fadeIn');
					if ($('#login-button').text() == 'Login') {
						$('#login-button').text('Close');
					} else {
						$('#login-button').text('Login');
					}
				});

				$('.nav-search').on('click', function() {
					$('.topnav form').toggleClass('hide-me').addClass('animated fadeIn');
					$('.topnav .desktop-menu').toggleClass('hide-me');
				});

				$('#mobile-search').on('click', function() {
					$('.topnav form').toggleClass('hide-me').addClass('animated fadeIn');
				});

				$('.topnav .mobile-menu #mobile-login-button').on('click', function(e){
					e.preventDefault();
					if ($('html').hasClass('ie')){
						if ($('#mobile-login-button').text() === 'Login') {
							$('#login-mobile').show();
							setTimeout(function() {
								$('#mobile-login-button').text('Hide Login');
							}, 50);
						} 
						if ($('#mobile-login-button').text() === 'Hide Login') {
							$('#login-mobile').hide();
							setTimeout(function() {
								$('#mobile-login-button').text('Login');
							}, 50);
						}
					} else {
						if ($('#login-mobile').attr('style') === ''){
							$('#login-mobile').css('display', 'block').addClass('animated fadeIn');
							$('#mobile-login-button').text('Hide Login');
						} else {
							$('#login-mobile').attr('style', '');
							$('#mobile-login-button').text('Login');
						}
					}
				});

				$('#exit-mobile-menu').on('click', function(e){
					e.preventDefault();
					$('.topnav').attr('style', '');
					$('.mobile-menu').toggleClass('hide-me');
					$("#item").removeClass();
				});

				$('#search-box #close-search').on('click', function(e) {
					e.preventDefault();
					$('.topnav .desktop-menu').removeClass('hide-me').addClass('animated fadeIn');
					$('.topnav form').addClass('hide-me');
				});

				$('.mobile-menu .sub-menu').hide();

				$('#menu-left-nav-1').append('<li class="nav-search menu-item"><a href="/contact">Contact</a></li>')

				$('li.menu-item-has-children').on('click', function(){
					$('.sub-menu').toggle('slow');
				})


				if ($('body').hasClass('single')){				
					$(".blog-content a h4").text(function(i,t){
						return t.length > 48 ? t.substr(0,45) + "..." : t;
					});
				};
				if ($('body').hasClass('sitemap')){	
					$('.page-item-37').css('display', 'none');			
					$('.page-item-39').css('display', 'none');
				};
				
				// Scroll To
				(function() {
					$('.scrollto').on('click', function(e){
						e.preventDefault();
						var section = $(this).attr('href');
						$('html, body').animate({
				            scrollTop: $(section).offset().top
				        }, 1000);
					});
				})();

				// add empty style attr to login mobile
				(function() {
					$('#login-mobile').attr('style', '');
				})();

				// Form
				(function() {
					$('select').selectric();
				})();

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},

		// Home page
		'page_template_template_home': {
			init: function() {

				if ($('html').hasClass('firefox')) {
					$('#briljent-hero-content .row:last-of-type svg').css('display', 'none');
					$('#briljent-hero-content .row:last-of-type').prepend('<img class="down" src="wp-content/themes/briljent/dist/images/orange-down.png" alt="scroll to next section" />');
				}

				var body = document.querySelector('body');
				$(body)
					.css('overflow-x', 'hidden')
					.css('background', 'linear-gradient(to bottom, rgba(242,244,246,0.9), rgba(255,255,255,1)),url(wp-content/themes/briljent/dist/images/Briljent_2017_Chicago.jpg) no-repeat center center fixed')
					.css('-webkit-background-size', 'cover')
					.css('-o-background-size', 'cover')
					.css('-moz-background-size', 'cover')
					.css('background-size', 'cover');

				$('header.header').css('border-bottom', 'none');
						
				$("#home-who-we-are #home-overview-img a p:nth-of-type(2)").text(function(i,t){
					return t.length > 55 ? t.substr(0,52) + "..." : t;
				});
				(function(){
					$("#main #home-who-we-are #home-overview-img a p:nth-of-type(2)").text(function(i,t){
						return t.length > 48 ? t.substr(0,45) + "..." : t;
					});
                })();
			

				$('#briljent-hero-content a, #briljent-hero-content .down, #briljent-hero-mobile a, #briljent-hero-mobile svg').click(function(e) {
					e.preventDefault();
					$('html, body').animate({
						scrollTop: $('#home-who-we-are').offset().top
					}, 500);
				});

				function changeBackground(){
					$('#main #home-who-we-are #home-overview-img a svg:nth-of-type(2)').toggleClass('filled');
				}
				function revertBackground(){
					$('#main #home-who-we-are #home-overview-img a svg:nth-of-type(2)').toggleClass('filled');
				}
				$('#home-overview-img a').hover(changeBackground, revertBackground);

				function changeBackgroundParent(){
					$('#home-overview-img a img').attr('src', 'wp-content/themes/briljent/dist/images/arrow-hover.svg');
					$('#home-overview-img a img').css('transform', 'rotate(0deg)');
				}
				function revertBackgroundParent(){
					$('#home-overview-img a img').attr('src', 'wp-content/themes/briljent/dist/images/arrow.svg');
					$('#home-overview-img a img').css('transform', 'rotate(180deg)');
				}
		
				var homeSlider = [].slice.call(document.querySelectorAll('#home-what-we-do .home-slider ol li'));
				var progressBar = document.querySelector('.progress');
				function romanize(num) {
					var lookup = {M:1000,CM:900,D:500,CD:400,C:100,XC:90,L:50,XL:40,X:10,IX:9,V:5,IV:4,I:1},roman = '',i;
					for ( i in lookup ) {
						while ( num >= lookup[i] ) {
						roman += i;
						num -= lookup[i];
						}
					}
					return roman;
				}

				function makeOL(array) {
					var list = document.createElement('ol');
					for (var i = 0; i < 3; i++) {
						var item = document.createElement('li');
						item.appendChild(document.createTextNode((romanize(i + 1)) + "."));
						list.appendChild(item);
					}
					return list;
				}

				progressBar.appendChild(makeOL(homeSlider));

				$('.controls img:first-of-type').click(function(e) {
					var sliderList = $('#home-what-we-do .home-slider #home-slider-content li');
					var activeList = $('#home-what-we-do .home-slider #home-slider-content li.active-li');
					var links = $('#home-what-we-do ul li');
					var activeLink = $('#home-what-we-do ul li.active-li');
					var theList = $('.progress ol li');					
					var activeList = $('#home-what-we-do .home-slider #home-slider-content li.active-li');
					
					if (activeLink.prev('li').length) {
						activeLink.removeClass('active-li');
						activeLink.prev('li').addClass('active-li');
					}
					
					if (activeList.prev('li').length){
						var theIndex = $(activeList).index() + 1;
						$(theList[0]).text(romanize(theIndex - 1) + ".");

						if ($(activeList).index() < sliderList.length) {
							$(theList[1]).text(romanize((theIndex)) + ".").css('color', '#446279');
						} else {
							$(theList[1]).css('color', '#ffffff');
						}

						if ($(activeList).index() < sliderList.length - 1) {
							$(theList[2]).text(romanize(theIndex + 1) + ".").css('color', '#446279');
						} else {
							$(theList[2]).css('color', '#ffffff');
						}
	
						$('#home-what-we-do .home-slider #home-slider-content li.active-li img').addClass('animated slideOutRight');
						$('#home-what-we-do .home-slider #home-slider-content li.active-li .content-header').addClass('animated fadeOut');
						$('#home-what-we-do .home-slider #home-slider-content li.active-li .content-box').addClass('animated fadeOut');

						setTimeout(function(){	
							$('#home-what-we-do .home-slider #home-slider-content li.active-li img').removeClass('animated slideOutRight');
							$('#home-what-we-do .home-slider #home-slider-content li.active-li .content-header').removeClass('animated fadeOut');
							$('#home-what-we-do .home-slider #home-slider-content li.active-li .content-box').removeClass('animated fadeOut');
							activeList.removeClass('active-li');
							activeList.prev().addClass('active-li');
							$('#home-what-we-do .home-slider #home-slider-content li.active-li img').addClass('animated slideInRight');
							$('#home-what-we-do .home-slider #home-slider-content li.active-li .content-header').addClass('animated fadeIn');
							$('#home-what-we-do .home-slider #home-slider-content li.active-li .content-box').addClass('animated fadeIn');
						}, 1000);
					}
					
				});
				$('.controls img:nth-of-type(2)').click(function() {
					var sliderList = $('#home-what-we-do .home-slider #home-slider-content li');
					var activeList = $('#home-what-we-do .home-slider #home-slider-content li.active-li');
					var links = $('#home-what-we-do ul li');
					var activeLink = $('#home-what-we-do ul li.active-li');
					var theList = $('.progress ol li');

					if (activeLink.next('li').length) {
						activeLink.removeClass('active-li');
						activeLink.next('li').addClass('active-li');
					}

					if (activeList.next('li').length){
						var theIndex = $(activeList).index() + 1;
						$(theList[0]).text(romanize(theIndex + 1) + ".");

						if ($(activeList).index() < sliderList.length - 2) {
							$(theList[1]).text(romanize(theIndex + 2) + ".");
						} else {
							$(theList[1]).css('color', '#ffffff');
						}

						if ($(activeList).index() < sliderList.length - 3) {
							$(theList[2]).text(romanize(theIndex + 3) + ".");
						} else {
							$(theList[2]).css('color', '#ffffff');
						}

						$('#home-what-we-do .home-slider #home-slider-content li.active-li img').addClass('animated slideOutRight');
						$('#home-what-we-do .home-slider #home-slider-content li.active-li .content-header').addClass('animated fadeOut');
						$('#home-what-we-do .home-slider #home-slider-content li.active-li .content-box').addClass('animated fadeOut');
						setTimeout(function(){
							$('#home-what-we-do .home-slider #home-slider-content li.active-li img').removeClass('animated slideOutRight');
							$('#home-what-we-do .home-slider #home-slider-content li.active-li .content-header').removeClass('animated fadeOut');
							$('#home-what-we-do .home-slider #home-slider-content li.active-li .content-box').removeClass('animated fadeOut');	
							activeList.removeClass('active-li');
							activeList.next().addClass('active-li');
							$('#home-what-we-do .home-slider #home-slider-content li.active-li img').addClass('animated slideInRight');
							$('#home-what-we-do .home-slider #home-slider-content li.active-li .content-header').addClass('animated fadeIn');
							$('#home-what-we-do .home-slider #home-slider-content li.active-li .content-box').addClass('animated fadeIn');
						}, 1000);
						// activeList.removeClass('active-li');
					}
				});

					if (window.matchMedia("(min-width: 960px)").matches) {
						var slideInFromRight = new Waypoint({
						element: document.querySelector('#home-who-we-are'),
						handler: function() {
							$('#home-overview-img img').addClass('slide-in-from-right-index');
							$('#home-overview-img a').addClass('slide-in-from-right-index');
						},
						offset: '15%'
					});
				}
			
				var homePatternRow = $('.home-pattern-row');
				for (var i = 0; i < homePatternRow.length; i++) {
					new Waypoint({
						element: homePatternRow[i],
						handler: function() {
							var delay = 0;
							var sq = $(this.element).children().children('.square')
							sq.each(function(){
								$(this).delay(delay).animate({
									opacity:1
								},100);
								delay += 100;
							});
						},
						offset: '85%'
					});
				};

				var trianglePatterns = $('#who-we-work-with .row .numbers-content');
				for (var t = 0; t < trianglePatterns.length; t++) {
					new Waypoint({
						element: trianglePatterns[t],
						handler: function() {
							$(this.element).parent().siblings().children().find('svg:nth-of-type(1)').addClass('tilted-odd');
							$(this.element).parent().siblings().children().find('svg:nth-of-type(2)').addClass('tilted-even');
						},
						offset: '50%'
					});
				};

			},
			finalize: function() {
				// JavaScript to be fired on the home page, after the init JS
			}
		},
		'page_template_template_resources': {
			init: function() {
				var signUp = document.getElementById('become-a-partner');
				var caseLinks = [].slice.call(document.querySelectorAll('.case-study a'));
				var paperLinks = [].slice.call(document.querySelectorAll('.whitepaper a'));
				var allLinks = caseLinks.concat(paperLinks);

				var navTabs = [].slice.call(document.querySelectorAll('#resources-banner #resources-anchors a'));

				function handleNavClick(e) {
					e.preventDefault();
					var link = this.getAttribute('href');
					console.log(link);
					$('html, body').animate({
						scrollTop: $(link).offset().top
					}, 500);
				}

				navTabs.forEach(function(navT) {
					navT.addEventListener('click', handleNavClick);
				});

				
                //
                (function () {

                    $('.row .resource-btn').on('click', function (event) {

                        // Only open the form popup if no cookie.
                        // Otherwise just open the file
                        if (!$(this).hasClass('download')) {
                            event.preventDefault();
                            /// get value and assign to gravity form hidden input field
							$(this).addClass("activated");
                            var parent = $(this).parent();
                            var myTitle = $(parent).find('.resource-title').text();
                            $('#resources').attr('data-clicked-id', $(this).parent().parent().attr('id'));
                            $('#become-a-partner #input_2_8').val(myTitle);
                            $('#become-a-partner').addClass('slide-to-the-right');
							// $('html').css('overflow', 'noscroll');
							$('header').css('z-index', "-1");
							$('footer').css('z-index', "-1");
						} 
                         $('#become-a-partner img').on('click', function() {
                            $('#become-a-partner').removeClass('slide-to-the-right');
							$('footer').css('z-index', "99999");
							$('header').css('z-index', "99999");
							// $('html').css('overflow', 'auto');
                            location.reload();
                        });

                    });
                })();

			},
		},
		'page_template_template_blog': {
			init: function() {
				(function(){
					$(".blog-content a h4").text(function(i,t){
						return t.length > 48 ? t.substr(0,45) + "..." : t;
					});
                })();
				var mySwiper = new Swiper ('#blog-swiper', {
					direction: 'horizontal',
					slidesPerView: 3,
					pagination: '.swiper-pagination',
					nextButton: '.swiper-button-next',
					prevButton: '.swiper-button-prev',
					scrollbar: '.swiper-scrollbar',
					spaceBetween: 25,
					breakpoints: {
						900:{
							slidesPerView: 2
						},
						// when window width is <= 480px
						568: {
							slidesPerView: 1,
							spaceBetween: 20
						}
					}
				});        
			},
		},
		'page_template_template_partnerships':{
			init: function() {
				var partnersContainer = document.querySelector('#partners');
				var partners = [].slice.call(document.querySelectorAll('#partners ul li'));

				function changeBackground() {
					var newBackground = this.dataset.background;
					var theContent = this.querySelector('.partner-content');
					partnersContainer.style.background = 'linear-gradient(rgba(83,47,100,0.85), rgba(83,47,100,0.85)), url(' + newBackground + ')';
					theContent.style.visibility = 'visible';
				}

				function revertBackground() {
					var theContent = this.querySelector('.partner-content');
					partnersContainer.style.background = '#532F64';
					theContent.style.visibility = 'hidden';
				}

				partners.forEach(function(partner) {
					partner.addEventListener('mouseover', changeBackground);
					partner.addEventListener('mouseout', revertBackground);
				});
			}
		},
		'page_template_template_industries': {
			init: function() {

				var navTabs = [].slice.call(document.querySelectorAll('#industries-banner ul li a'));

				function handleNavClick(e) {
					e.preventDefault();
					var link = this.getAttribute('href');
					console.log(link);
					$('html, body').animate({
						scrollTop: $(link).offset().top
					}, 500);
				}

				navTabs.forEach(function(navT) {
					navT.addEventListener('click', handleNavClick);
				});


				var swiperOne = new Swiper('.industry-swiper-one', {
						direction: 'horizontal',
						effect: 'fade',					
						slidesPerView: 1,								
						nextButton: '#swiper-one-next',
						prevButton: '#swiper-one-prev',
						scrollbar: '.swiper-scrollbar',
				});

				var slideArray = swiperOne.slides;
				var next = document.getElementById('swiper-one-next');
				var prev = document.getElementById('swiper-one-prev');

				function updateIndexView() {
					var prevIndex = swiperOne.activeIndex;
					var currentIndex = swiperOne.activeIndex + 1;
					var nextIndex = swiperOne.activeIndex + 2;
					if (swiperOne.slides.length > 0 ) {
						if (prevIndex > 0) {
							$('#swiper-one-index h4:nth-of-type(1)').html("0" + prevIndex);
						} else {
							$('#swiper-one-index h4:nth-of-type(1)').html(' ');
						}
						$('#swiper-one-index h3').html("0" + currentIndex);
						if(nextIndex < swiperOne.slides.length + 1) {
							$('#swiper-one-index h4:nth-of-type(2)').html("0" + nextIndex);
						} else {
							$('#swiper-one-index h4:nth-of-type(2)').html(' ');
						}
					}
				}

				next.addEventListener('click', updateIndexView);
				prev.addEventListener('click', updateIndexView);

				$('#industries-break a').click(function(e) {
					e.preventDefault();
					$('html, body').animate({
						scrollTop: $('#contracting-vehicles-two').offset().top
					}, 500);
				});

				var vehicleTabs =[].slice.call(document.querySelectorAll('#contracting-vehicles-nav ul li'));
				var vehicleContent = [].slice.call(document.querySelectorAll('#contracting-vehicles-content ul li'));

				function handleSwitch() {
					vehicleTabs.forEach(function(tab) {
						tab.classList.remove('active-border');
					});
					this.classList.add('active-border');

					vehicleContent.forEach(function(tab) {
						tab.classList.remove('active');
					});
					var theIndex = vehicleTabs.indexOf(this);
					vehicleContent[theIndex].classList.add('active');
					$('html, body').animate({
						scrollTop: $(vehicleContent[theIndex]).offset().top
					}, 500);
				}

				vehicleTabs.forEach(function(tab) {
					tab.addEventListener('click', handleSwitch);
				});

				$('#previous-contracting-vehicle, #next-contracting-vehicle').on('click', function(e) {
					var target = $(e.target);
					var currentActive = $('#contracting-vehicles-content ul li.active');
					var currentBorder = $('#contracting-vehicles-nav ul li.active-border');

					if (target.is('#next-contracting-vehicle')) {
						$('#previous-contracting-vehicle').css('opacity', '1');
						var nextActive = currentActive.next('#contracting-vehicles-content ul li');
						var nextBorder = currentBorder.next('#contracting-vehicles-nav ul li');
						if (currentActive.next().is('li')) {
							currentActive.removeClass('active');
							nextActive.addClass('active');
							$('html, body').animate({
								scrollTop: nextActive.offset().top - 100
							}, 500);
						} else{
							$('#next-contracting-vehicle').css('opacity', '0.5');
						}

						if (currentBorder.next().is('li')) {
							currentBorder.removeClass('active-border');
							nextBorder.addClass('active-border');
						}
					}

					if (target.is('#previous-contracting-vehicle')) {
						var prevActive = currentActive.prev('#contracting-vehicles-content ul li');
						var prevBorder = currentBorder.prev('#contracting-vehicles-nav ul li');
						if (currentActive.prev().is('li')) {
							currentActive.removeClass('active');
							prevActive.addClass('active');
							$('html, body').animate({
								scrollTop: prevActive.offset().top - 100
							}, 500);
							$('#next-contracting-vehicle').css('opacity', '1');
						} else{
							$('#previous-contracting-vehicle').css('opacity', '0.5');
						}

						if (currentBorder.prev().is('li')) {
							currentBorder.removeClass('active-border');
							prevBorder.addClass('active-border');
						}
					}

				});

				$(window).on('resize load', function(){
					if (window.matchMedia("(max-width: 650px)").matches) {
						var quotes = [].slice.call(document.querySelectorAll('#industries #industry-testimonials .wrapper .swiper-container .swiper-wrapper .swiper-slide h3'));
						quotes.forEach(function(q) {
							q.innerHTML = '"';
						});
					}
				});


				var industryPatternRow = $('.industry-pattern-row');
				for (var i = 0; i < industryPatternRow.length; i++) {
					new Waypoint({
						element: industryPatternRow[i],
						handler: function() {
							var delay = 0;
							var sq = $(this.element).children().children('.square')
							sq.each(function(){
								$(this).delay(delay).animate({
									opacity:1
								},100);
								delay += 100;
							});
						},
						offset: '85%'
					});
				};
				var trianglePatterns = $('#industry-areas ul li');
				for (var t = 0; t < trianglePatterns.length; t++) {
					new Waypoint({
						element: trianglePatterns[t],
						handler: function() {
							$(this.element).children().find('svg:nth-of-type(1)').addClass('tilted-industries-odd');
							$(this.element).children().find('svg:nth-of-type(2)').addClass('tilted-industries-even');
						},
						offset: '50%'
					});
				};
			}
		},
		'page_template_template_services': {
			init: function() {

				var navTabs = [].slice.call(document.querySelectorAll('#services-banner ul li a'));

				function handleNavClick(e) {
					e.preventDefault();
					var link = this.getAttribute('href');
					$('html, body').animate({
						scrollTop: $(link).offset().top
					}, 500);
				}

				navTabs.forEach(function(navT) {
					navT.addEventListener('click', handleNavClick);
				});

				var serviceOneSwiper = new Swiper('.services-swiper-one', {
						direction: 'horizontal',					
						slidesPerView: 1,								
						nextButton: '#next-component',
						prevButton: '#previous-component',
				});

				var slideTitles = [].slice.call(document.querySelectorAll('.services-swiper-one .swiper-slide h3'));
				var slideNav = document.querySelector('#services-swiper-one-nav ul');
				
				for (var a = 0; a < slideTitles.length; a++) {
					var o = slideTitles[a].textContent;				
					var li = document.createElement('li');
					li.appendChild(document.createTextNode(o));
					slideNav.appendChild(li);
				}

				$('#services-swiper-one-nav ul li:nth-of-type(1)').addClass('active-border');

				var slideNavList = [].slice.call(document.querySelectorAll('#services-swiper-one-nav ul li'));
				var slides = [].slice.call(document.querySelectorAll('.services-swiper-one .swiper-slide'));

				function handleSwitch(e) {
					slideNavList.forEach(function(nav) {
						nav.classList.remove('active-border');
					});
					this.classList.add('active-border');
					var theIndex = slideNavList.indexOf(this);
					serviceOneSwiper.slideTo(theIndex, 1000, false);
				}

				slideNavList.forEach(function(nav) {
					nav.addEventListener('click', handleSwitch);
				});

				$('#next-component').on('click', function() {
					var currentBorder = $('#services-swiper-one-nav ul li.active-border');
					var nextBorder = currentBorder.next('#services-swiper-one-nav ul li');
					
					if (currentBorder.next().is('li')) {
						currentBorder.removeClass('active-border');
						nextBorder.addClass('active-border');
					}

					$('#previous-component').css('opacity', '1');
				});

				$('#previous-component').on('click', function() {
					var currentBorder = $('#services-swiper-one-nav ul li.active-border');
					var prevBorder = currentBorder.prev('#services-swiper-one-nav ul li');
					
					if (currentBorder.prev().is('li')) {
						currentBorder.removeClass('active-border');
						prevBorder.addClass('active-border');
					}
				});

				var serviceTwoSwiper = new Swiper('.services-swiper-two', {
						direction: 'horizontal',
						effect: 'fade',					
						slidesPerView: 1,								
						nextButton: '#services-swiper-two-next',
						prevButton: '#services-swiper-two-prev',
						scrollbar: '.swiper-scrollbar',
				});
				var slideArray = serviceTwoSwiper.slides;
				var next = document.querySelector('#services-swiper-two-next');
				var prev = document.querySelector('#services-swiper-two-prev');

				(function() {
					if ($('.services-swiper-two .swiper-slide').size() > 1) {
						$('#services-swiper-two-index h4:nth-of-type(2)').html("02");
					}
					if ($('.services-swiper-two .swiper-slide').size() <= 1) {
						$('#services-swiper-two-prev').css('visibility', 'hidden');
						$('#services-swiper-two-next').css('visibility', 'hidden');
					}
				})();

				function updateIndexView() {
					var prevIndex = serviceTwoSwiper.activeIndex;
					var currentIndex = serviceTwoSwiper.activeIndex + 1;
					var nextIndex = serviceTwoSwiper.activeIndex + 2;
					if (serviceTwoSwiper.slides.length > 0 ) {
						if (prevIndex > 0) {
							$('#services-swiper-two-index h4:nth-of-type(1)').html("0" + prevIndex);
						} else {
							$('#services-swiper-two-index h4:nth-of-type(1)').html(' ');
						}
						$('#services-swiper-two-index h3').html("0" + currentIndex);
						if(nextIndex < serviceTwoSwiper.slides.length + 1) {
							$('#services-swiper-two-index h4:nth-of-type(2)').html("0" + nextIndex);
						} else {
							$('#services-swiper-two-index h4:nth-of-type(2)').html(' ');
						}
					}
				}

				next.addEventListener('click', updateIndexView);
				prev.addEventListener('click', updateIndexView);

				$(window).on('resize load', function() {

					if(window.matchMedia("(min-width: 991px)").matches) {
						$('.mobile-service-one').hide();
					}

					if (window.matchMedia("(max-width: 990px)").matches) {
						var serviceSlides = [].slice.call(document.querySelectorAll('#services #components-slider .row .services-swiper-one .swiper-wrapper .swiper-slide .services-swiper-one-text'));

						function makeUL(array) {
							var list = document.createElement('ul');
							list.classList.add('mobile-service-one');
							for(var i = 0; i < array.length; i++) {
								var background = document.querySelector('.services-swiper-one').style.background;
								var item = document.createElement('li');
								item.style.background = background;
								var theDiv = document.createElement('div');
								var header = document.createElement('h3');
								var image = document.createElement('img');
								var paragraph = document.createElement('p');
								if(array[i].querySelector('ul')) {
                                    var innerList = document.createElement('ul');
                                    var innerListItemsArr = array[i].querySelectorAll('li');
									for(var m = 0; m < innerListItemsArr.length; m++){
										var innerListItem = document.createElement('li');
										innerListItem.appendChild(document.createTextNode(innerListItemsArr[m].textContent));
										innerList.appendChild(innerListItem);
									}
									var hasList = 1;
                                }else {
									var hasList = 0;
								}
								header.appendChild(document.createTextNode(array[i].querySelector('h3').textContent));
								image.setAttribute('src', array[i].querySelector('img').getAttribute('src'));
								paragraph.appendChild(document.createTextNode(array[i].querySelector('p').textContent));
								theDiv.classList.add('mobile-service-one-content');
								theDiv.appendChild(header);
								theDiv.appendChild(image);
								theDiv.appendChild(paragraph);
								if(hasList === 1){
									theDiv.appendChild(innerList);
								}
								item.appendChild(theDiv);
								list.appendChild(item);
							}
							return list;
						}
						document.getElementById('components-slider').appendChild(makeUL(serviceSlides));
						$('.mobile-service-one:first-of-type').show();
					}
					if (window.matchMedia("(max-width: 650px)").matches) {
						var quotes = [].slice.call(document.querySelectorAll('#services #services-testimonials .wrapper .swiper-container .swiper-wrapper .swiper-slide h3'));
						quotes.forEach(function(q) {
							q.innerHTML = '"';
						});
					}
					if (window.matchMedia("(max-width: 450px)").matches) {
					}
					if (window.matchMedia("(max-width: 375px)").matches) {
						$('#service-testimonials .services-swiper-two .swiper-slide h3').text('"');
					}
				});
			}
		},
		'page_template_template_careers': {
			init: function() {

				var navTabs = [].slice.call(document.querySelectorAll('#careers-banner ul li a'));

				function handleNavClick(e) {
					e.preventDefault();
					var link = this.getAttribute('href');
					console.log(link);
					$('html, body').animate({
						scrollTop: $(link).offset().top
					}, 500);
				}

				navTabs.forEach(function(navT) {
					navT.addEventListener('click', handleNavClick);
				});

				function changeBackground(){
					$('#main #home-who-we-are #home-overview-img a svg:nth-of-type(2)').toggleClass('filled');
				}
				function revertBackground(){
					$('#main #home-who-we-are #home-overview-img a svg:nth-of-type(2)').toggleClass('filled');
				}
				$('#home-overview-img a').hover(changeBackground, revertBackground);

				$('#overview-img').hover(function(){
					var svg = $(this).find('p').children();
					svg.toggleClass('filled')
				});
				function changeBackgroundParent(){
					$('#overview-img a p img').attr('src', '/wp-content/themes/briljent/dist/images/arrow-hover.svg');
					$('#overview-img a p img').css('transform', 'rotate(0deg)');
				}
				function revertBackgroundParent(){
					// $('#overview-img a #overview-hero-bottom').attr('src', 'wp-content/themes/briljent/dist/images/careers-overview-stock-bottom.svg');
					$('#overview-img a p img').attr('src', '/wp-content/themes/briljent/dist/images/arrow.svg');
					$('#overview-img a p img').css('transform', 'rotate(180deg)');
				}
				$('#overview-img a').hover(changeBackgroundParent, revertBackgroundParent);

				var careerSwiperOne = new Swiper('.career-swiper-one', {
						direction: 'horizontal',
						// effect: 'fade',	
						centeredSlides: true,				
						slidesPerView: 1,								
						nextButton: '#career-swiper-one-next',
						prevButton: '#career-swiper-one-prev',
						scrollbar: '.swiper-scrollbar',
				});

				$('#communication-creed ol li').addClass('blur');

				var commCreed = $('#communication-creed ol li');
				for (var c = 0; c < commCreed.length; c++) {
					new Waypoint({
						element: commCreed[c],
						handler: function(direction) {
							if (direction === 'down'){
								$(this.element).removeClass('blur');
							} else {
								$(this.element).addClass('blur');
							}
						},
						offset: '40%'
					});
				};

				var targetOffsetStart = $("#non-negotiables-nav").offset().top;
				var targetOffsetEnd = $("#work-with-us").offset().top - 520;
				var fixedNnn = new Waypoint({
					element: document.getElementById('non-negotiables-nav'),
					handler: function(direction) {
						if (direction === 'down'){
							$(this.element).addClass('fixed-nnn');
						} else {
							$(this.element).removeClass('fixed-nnn');
						}
					},
				});
				var fixedNnnRemove = new Waypoint({
					element: document.getElementById('work-with-us'),
					handler: function(direction) {
						if (direction === 'down'){
							$('#non-negotiables-nav').removeClass('fixed-nnn');
							$('#non-negotiables-nav').addClass('fixed-nnn-bottom');
						} else {
							$('#non-negotiables-nav').removeClass('fixed-nnn-bottom');
							$('#non-negotiables-nav').addClass('fixed-nnn');
						}
					},
					offset: '50%'
				});

				var nonNegotiables =[].slice.call(document.querySelectorAll('#non-negotiables-nav ul li'));
				var nonContent = [].slice.call(document.querySelectorAll('#non-negotiables-content ul li'));

				function handleSwitch() {
					nonNegotiables.forEach(function(tab) {
						tab.classList.remove('active-border');
					});
					this.classList.add('active-border');

					nonContent.forEach(function(tab) {
						tab.classList.remove('active');
					});
					var theIndex = nonNegotiables.indexOf(this);
					nonContent[theIndex].classList.add('active');
					$('html, body').animate({
						scrollTop: $(nonContent[theIndex]).offset().top
					}, 500);
				}

				nonNegotiables.forEach(function(tab) {
					tab.addEventListener('click', handleSwitch);
				});

				$('#next-non-negotiable').on('click', function() {
					var currentActive = $('#non-negotiables-content ul li.active');
					var nextActive = currentActive.next('#non-negotiables-content ul li');

					var currentBorder = $('#non-negotiables-nav ul li.active-border');
					var nextBorder = currentBorder.next('#non-negotiables-nav ul li');
					
					if (currentBorder.next().is('li')) {
						currentBorder.removeClass('active-border');
						nextBorder.addClass('active-border');
					}

					$('#previous-non-negotiable').css('opacity', '1');

					if (currentActive.next().is('li')) {
						currentActive.removeClass('active');
						nextActive.addClass('active');
						$('html, body').animate({
							scrollTop: nextActive.offset().top - 100
						}, 500);
					} else{
						$('#next-non-negotiable').css('opacity', '0.5');
					}
				});

				$('#previous-non-negotiable').on('click', function() {
					var currentActive = $('#non-negotiables-content ul li.active');
					var prevActive = currentActive.prev('#non-negotiables-content ul li');

					var currentBorder = $('#non-negotiables-nav ul li.active-border');
					var prevBorder = currentBorder.prev('#non-negotiables-nav ul li');
					
					if (currentBorder.prev().is('li')) {
						currentBorder.removeClass('active-border');
						prevBorder.addClass('active-border');
					}

					if (currentActive.prev().is('li')) {
						currentActive.removeClass('active');
						prevActive.addClass('active');
						$('html, body').animate({
							scrollTop: prevActive.offset().top - 100
						}, 500);
						$('#next-non-negotiable').css('opacity', '1');
					} else{
						$('#previous-non-negotiable').css('opacity', '0.5');
					}
				});
				// 
				$(window).on('resize load', function() {
					if (window.matchMedia("(max-width: 650px)").matches) {
						$('#careers #careers-banner ul').css('padding', '13px 0 0');
						$('#careers #careers-banner ul li').css('display', 'block');
						$('#careers #careers-banner ul li a').css('padding', '0');

						// style quote box author section
						var text = [].slice.call(document.querySelectorAll('#careers #overview #overview-slider .career-swiper-one .swiper-slide p:nth-of-type(2) span'));
						text.forEach(function(t){
							t.appendChild(document.createElement('br'));
							var noComma = t.innerHTML.replace(/,/g, '');
							t.innerHTML = noComma;
						});
					}
				});
			}
		},
		'page_template_template_about': {
			init: function() {

				if ($('html').hasClass('firefox')) {
					$('#about-down a svg').css('display', 'none');
					$('#about-down a').prepend('<img class="down" src="/wp-content/themes/briljent/dist/images/orange-down.png" alt="scroll to next section" />');
					$('#about-down a img.down').css('transform', 'rotate(-90deg)');
				}

				var fixedBio = new Waypoint({
					element: document.querySelector('#right-leadership'),
					handler: function(direction) {
						if (direction === 'down'){
							$(this.element).addClass('fixed');
						} else {
							$(this.element).removeClass('fixed');
						}
					},
				});
				var fixedBioRemove = new Waypoint({
					element: document.querySelector('#default-bottom-banner'),
					handler: function(direction) {
						if (direction === 'down'){
							$('#right-leadership').removeClass('fixed');
							$('#right-leadership').addClass('fixed-bottom');
						} else {
							$('#right-leadership').removeClass('fixed-bottom');
							$('#right-leadership').addClass('fixed');
						}
					},
					offset: '100%'
				});

				$('#left-leadership ul li:nth-of-type(1) img').addClass('active-bio');

				var leaders = $('#left-leadership ul li');

				function bioSwitch(el){
					var name = $(el).children('p:first-of-type').text();
					var title = $(el).children('p:nth-of-type(2)').text()
					var linkedIn = $(el).children('.hidden-bio').children('a').attr('href');
					var theBio = $(el).children('.hidden-bio').children('.post-content').html();
					console.log(linkedIn);

					$('#right-leadership h3').html(name);
					$('#right-leadership h4').html(title);
					$('#right-leadership a').attr('href', linkedIn);
					$('#right-leadership #the-bio p').html(theBio);
					$(el).prev().addClass('blur');
					$(el).prev().children('img').removeClass('active-bio').addClass('shrink');
				}

				for (var i = 0; i < leaders.length; i++) {
					new Waypoint({
						element: leaders[i],
						handler: function(direction) {
							if (direction === 'down'){
								var that = $(this.element);
								$(this.element).removeClass('blur');
								$(this.element).children('img').removeClass('shrink').addClass('active-bio');
								bioSwitch(that);
							} else {
								$(this.element).addClass('blur');
								$(this.element).children('img').removeClass('active-bio').addClass('shrink');
								var that = $(this.element).prev();
								if (that.length === 0){
									$('#left-leadership ul li:nth-of-type(1)').removeClass('blur');
									$('#left-leadership ul li:nth-of-type(1) img').removeClass('shrink').addClass('active-bio');
								}
								if (that.length){
									bioSwitch(that);
								}
								$(that).removeClass('blur');
								$(that).children('img').addClass('active-bio').removeClass('shrink');
							}
						},
						offset: '38.5%'
					});
				};

				var aboutRow = $('.about-pattern-row');
				for (var i = 0; i < aboutRow.length; i++) {
					new Waypoint({
						element: aboutRow[i],
						handler: function() {
							var delay = 0;
							var sq = $(this.element).children().children('.square')
							sq.each(function(){
								$(this).delay(delay).animate({
									opacity:1
								},100);
								delay += 100;
							});
						},
						offset: '60%'
					});
				};

				var leadershipTeam = [].slice.call(document.querySelectorAll('#left-leadership ul li'));
				var leaderBio = document.querySelector('#right-leadership');
				console.log(leaderBio);

				function handleLeaderClick() {
					leadershipTeam.forEach(function(leader){
						leader.querySelector('img:first-of-type').classList.remove('active-bio');
					})

					this.classList.remove('blur');
					this.querySelector('img:first-of-type').classList.remove('shrink');
					this.querySelector('img:first-of-type').classList.add('active-bio');

					var name = this.querySelector('p:first-of-type');
					var title = this.querySelector('p:nth-of-type(2)');
					var linkedIn = this.querySelector('.hidden-bio a').getAttribute('href');
					var theBio = [].slice.call(this.querySelectorAll('.hidden-bio p'));
					
					leaderBio.querySelector('h3').innerHTML = name.textContent;
					leaderBio.querySelector('h4').innerHTML = title.textContent;
					leaderBio.querySelector('a').setAttribute('href', linkedIn);
					leaderBio.querySelector('#the-bio').innerHTML = theBio.map(function(para) {
						return "<p>" + para.textContent + "</p>";
					});
				}

				leadershipTeam.forEach(function(leader) {
					leader.addEventListener('click', handleLeaderClick);
				});

				$('#about-down a').click(function(e) {
					e.preventDefault();
					$('html, body').animate({
						scrollTop: $('#about-who-we-are').offset().top
					}, 500);
				});
				
				var showBio = [].slice.call(document.querySelectorAll('#about #left-leadership .show-bio'));
				function showTheBio() {
					var parental = this.parentNode;
					var theBio = parental.querySelectorAll('.hidden-bio');
					var arrow = parental.querySelectorAll('.show-bio .show-bio-arrow');
					$(theBio).toggleClass('visible-bio');
					$(arrow).toggleClass('rotate');
					this.querySelector('p').textContent == 'show bio' ? this.querySelector('p').textContent = 'hide bio' : this.querySelector('p').textContent = 'show bio';
					
					
				}
				showBio.forEach(function(s){
					s.addEventListener('click', showTheBio);
				});
			}
		},
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function(func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = funcname === undefined ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function() {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);
})(window.jQuery, window.Clique); // Fully reference jQuery after this point.